// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { SHUTDOWN_TYPE } from '@/constant/rental';

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            shutdownType: SHUTDOWN_TYPE,

            dataNote: [
                {
                    label: 'Some things to note when shutdown machine',
                    children: [
                        {
                            label: '• Make sure to save your work results before you turn off the machine.',
                        },
                        {
                            label: '• How fast or slow the shutdown process takes depends on the size of your image.',
                        },
                        {
                            label: '• The shutdown process will back up your current computer status so you can continue working for the next time without having to reset the environment.',
                        },
                    ]
                },
            ],
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {

        //#region  Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.SHUTDOWN_MACHINE);
        },
        //#endregion

        //#region Shutdown machine
        shutdown(type) {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    shutdownType: type,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.SHUTDOWN_MACHINE, data)
                    .then((res) => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess('Shutdown success !', `Machine <span style="color: #42A5F5;"> #${this.targetImage.id} (${this.targetImage.name})</span> has been shutdown successfully</span>`);
                        if (res.data) {
                            setTimeout(() => {
                                EventBus.$emit("processingEventApp", {
                                    event: "processOpenPopup",
                                    data: {
                                        type: POPUP_ID.RATE_IMAGE,
                                        data: res.data,
                                    },
                                });
                            }, 500);
                            this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                        }
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Shutdown failed ...")
                    });
            }, this.smoothTimeOut);
        },
        //#endregion
    },
}